import { userAdapter, userProfessionAdapter, userRoleAdapter } from "../data/adapters/user";
import { IUserModel, IUserProfessionModel, IUserRoleModel } from "../data/models/user";
import { axiosInstance } from "../utils/axios";

export interface ICreateUserPayload {
  name: string;
  lastname: string;
  email: string;
  password: string;
  role: string;
  profession: string;
}

export interface IUpdateUserPayload {
  id: string;
  name: string;
  lastname: string;
  email: string;
  profession: string;
}

export interface ICreateProfessionPayload {
  name: string;
  description?: string;
  assets?: string[];
}

export interface IUpdateProfessionPayload {
  id: string;
  name: string;
  assets?: string[];
  description?: string;
}

// Admin Services
export const allUsers = () =>
  axiosInstance({ auth: true })
    .get("/admin/users")
    .then((res): IUserModel[] => {
      if (!res) throw new Error();

      if (res.data && !res.data.length) return [];

      return res.data.map((request: any) => userAdapter(request));
    });

export const allRoles = () =>
  axiosInstance({ auth: true })
    .get("/admin/roles")
    .then((res): IUserRoleModel[] => {
      if (!res) throw new Error();

      if (res.data && !res.data.length) return [];

      return res.data.map((request: any) => userRoleAdapter(request));
    });

export const createProfession = (profession: ICreateProfessionPayload) =>
  axiosInstance({ auth: true })
    .post("/admin/professions", profession)
    .then((res): IUserProfessionModel => {
      if (!res) throw new Error();

      return userProfessionAdapter(res.data);
    });

export const updateProfession = (profession: IUpdateProfessionPayload) =>
  axiosInstance({ auth: true })
    .put(`/admin/professions/${profession.id}`, profession)
    .then((res): IUserProfessionModel => {
      if (!res) throw new Error();

      return userProfessionAdapter(res.data);
    });

export const allProfessions = () =>
  axiosInstance({ auth: true })
    .get("/admin/professions")
    .then((res) => {
      if (!res) throw new Error();

      if (res.data && !res.data.length) return [];

      return res.data.map((request: any) => userProfessionAdapter(request));
    });

export const bulkDeleteProfessions = (ids: string[]) =>
  axiosInstance({ auth: true })
    .delete("/admin/professions", { data: { ids } })
    .then((res) => {
      if (!res) throw new Error();
    });

export const createUser = (user: ICreateUserPayload) =>
  axiosInstance({ auth: true })
    .post("/admin/users", user)
    .then((res): IUserModel => {
      if (!res) throw new Error();

      return userAdapter(res.data);
    });

export const bulkDeleteUsers = (ids: string[]) =>
  axiosInstance({ auth: true })
    .delete("/admin/users", { data: { ids } })
    .then((res) => {
      if (!res) throw new Error();
    });

export const updateUser = (user: IUpdateUserPayload) =>
  axiosInstance({ auth: true })
    .put(`/admin/users/${user.id}`, user)
    .then((res): IUserModel => {
      if (!res) throw new Error();

      return userAdapter(res.data);
    });
